(function($) {

    $(document).ready(function() {

        function matchStart(params, data) {
            params.term = params.term || '';
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                return data;
            }
            return false;
        }

        var contactsDropdown = $('.contacts-department-dropdown').select2({
            width: 'auto',
            // minimumResultsForSearch: -1,
            placeholder: $(this).data('placeholder'),
            language: {
                noResults: function () {
                    return "Rezultatų nerasta";
                }
            },
            matcher: function(params, data) {
                return matchStart(params, data);
            }
        });

        contactsDropdown.on('change', function () {
            var target = $(this).val();
            $('.powertip-dep[data-dep=' + target + ']').addClass('active');

            $([document.documentElement, document.body]).animate({
                scrollTop: $('.powertip-dep[data-dep=' + target + ']').offset().top - 500
            }, 500);

            setTimeout(function () {
                $.powerTip.show($('.powertip-dep[data-dep=' + target + ']'));
            }, 550);
        });
    });

    $('.powertip-dep').powerTip({
        placement: 'n',
        manual: true,
        smartPlacement: true
    });

    $('.powertip-dep').on('click', function (e) {
        e.stopPropagation();
        $('.powertip-dep').removeClass('active');
        $.powerTip.show($(this));
        $(this).addClass('active');
    });

    $('body').on('click', function(e) {
        if ($(e.target).closest('.dep-tooltip').length === 0) {
            $.powerTip.hide();
            $('.powertip-dep').removeClass('active');
        }
    })

    $('body').on('click', '.dep-close', function() {
        $.powerTip.hide();
        $('.powertip-dep').removeClass('active');
    });

})( jQuery );